export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 12a9 9 0 1118.001.001A9 9 0 013 12zm2 0c0 3.86 3.14 7 7 7s7-3.14 7-7-3.14-7-7-7-7 3.14-7 7zm3.71-1.2L11 13.09l4.31-4.29 1.41 1.41-5 5c-.2.19-.45.29-.71.29-.26 0-.51-.09-.71-.29l-3-3 1.41-1.41z\" fill=\"#ff00cb\" fill-opacity=\".9\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};